import { useGetActiveAuctionsQuery } from 'services/api/live-auction';

export function useHasActiveAuction() {
  const { data: auctions = { autoaxess: null, frontline: null, second_chance: null } } = useGetActiveAuctionsQuery();

  return Object.values(auctions).some(Boolean);
}
